import { useMutation, useQueryClient } from "@tanstack/react-query";
import { snoozeAlert } from "../../../api/alertsApi";

export const useSnoozeAlert = () => {
  const queryClient = useQueryClient();
  return useMutation(({ alertId, snoozedUntil }: { alertId: string; snoozedUntil: string }) => snoozeAlert(alertId, snoozedUntil), {
    // Same reasoning as useDismissAlert - refetch the ["alerts"] prefix rather than guess
    // client-side whether a just-snoozed alert should still show.
    onSuccess: () => queryClient.invalidateQueries(["alerts"]),
  });
};
